export const traineeList = "TRAINEE_LIST";
export const traineeLetter = "TRAINEE_LETTER";